import React from "react";
import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Text,
  View,
} from "react-native";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import Width from "../../../assets/Width";
import CustomButton from "../../../commonComponents/CustomButton";
import LottieComp from "../../../commonComponents/Lottie";
import {
  no_order_executed,
  no_order_placed,
  order_failed,
  txn_success,
  yes_order_executed,
  yes_order_placed,
  payment_block,
} from "../../../utils/images";
//import FastImage from 'react-native-fast-image';
import Colors from "../../../assets/Color/Colors";

const Error = ({ orderData, onDoneClick }) => {
  return (
    <View style={{ flex: 1 }}>
      {!orderData?.contactRelationshipManager ? (
        <LottieComp width={200} height={200} lottieJson={order_failed} />
      ) : (
        <FastImage
          resizeMode={FastImage.resizeMode.contain}
          style={{ height: 80, width: 80 }}
          source={payment_block()}
        />
      )}

      <Text style={[styles.orderStatusText, { color: Color.red }]}>
        {" "}
        {orderData?.error}
      </Text>
      <Text style={[styles.failedOrderText]}>{orderData?.message}</Text>

      <View style={[globalStyle.customBtnParentModalStyle]}>
        <CustomButton
          btnText={"Retry"}
          btnType={"normalBlue"}
          onBtnClick={() => {
            onDoneClick(orderData?.contactRelationshipManager ? false : true);
          }}
        />
      </View>
    </View>
  );
};

const ClubSettlementResponse = ({
  clubOrderResponse,
  onDoneClick,
  settleOrderHandler,
}) => {
  let successRes = clubOrderResponse?.success;

  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          width: Width.width - 30,
          flex: 1,
        }}
      >
        {!successRes ? (
          <Error onDoneClick={onDoneClick} orderData={clubOrderResponse} />
        ) : (
          <>
            <LottieComp
              width={200}
              height={200}
              lottieJson={yes_order_executed}
            />
            <Text
              style={[styles.orderStatusText, { color: Colors.tradexBlue }]}
            >
              {clubOrderResponse?.successTitle}
            </Text>
            <Text style={[styles.orderSubStatusText]}>
              {clubOrderResponse?.successSubtitle}
            </Text>

            <View style={[globalStyle.customBtnParentModalStyle]}>
              <CustomButton
                btnText="Done"
                btnType={"normalBlue"}
                onBtnClick={() => {
                  onDoneClick(false);
                }}
              />
            </View>
          </>
        )}
      </View>
    </View>
  );
};

export default ClubSettlementResponse;

const styles = StyleSheet.create({
  orderStatusText: {
    ...globalFontStyle.appFontTitle,
    alignSelf: "center",
    marginBottom: 20,
    textAlign: "center",
  },
  orderSubStatusText: {
    ...globalFontStyle.appFontBody,
    alignSelf: "center",
    textAlign: "center",
    marginBottom: 20,
  },
  textFontStyle: {
    ...globalFontStyle.appFontSubText,
    color: Color.black,
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 13,
  },
  tableContainer: {
    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: 3,
    paddingHorizontal: 18,
    paddingVertical: 15,
  },
  failedOrderText: {
    ...globalFontStyle.appFontBody,
    color: Color.lightgrey,

    textAlign: "center",
  },
});
